import SelectCollection from '@widesk-ui/components/form/SelectCollection';
import createSelect     from '@widesk-ui/tools/createSelect';
import PlaceModel       from '@models/map/PlaceModel';

/**
 * Pas de `renderForm` : `SelectCollection` en tire ses boutons "ajouter" et "modifier", qu'il rend
 * dans une MODALE — alors que l'éditeur passe par ses tiroirs. Les deux chemins existent à côté du
 * sélecteur, dans `AreaPlaceSection` : la création par `leftSidebarStore.openNewPlace`, la
 * modification par `leftSidebarStore.openPlace`.
 */
const Select = createSelect<typeof PlaceModel, {
	projectUrn: Urn;
}>(props => (
	<SelectCollection
		modelClass={PlaceModel}
		renderOption={m => m.renderName({ imageSize: 'small' })}
		sortName="label"
		sortWay="asc"

		{...props}
	/>
));

export default Select;
